import React, { memo } from "react";
import usePriceSubscription from "../../hooks/usePriceSubscription";
import MarketDataService from "../../services/market/MarketDataService";

const Spread = ({ symbol, style }) => {
    const price = usePriceSubscription(symbol);
    const meta = MarketDataService.getSymbolMeta(symbol);
    const digits = meta?.digits ?? price?.digits ?? 5;

    return (
        <span style={style}>
            S: {MarketDataService.formatSpreadInPips(price?.spread, digits, price)}
        </span>
    );
};

export default memo(Spread);
